import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  BottomNavigation,
  BottomNavigationAction,
} from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import FavoriteIcon from '@mui/icons-material/Favorite';
import MessageIcon from '@mui/icons-material/Message';
import PersonIcon from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings'; // Assuming you'll use a new icon for 'Admin'
import { getAuth, onAuthStateChanged } from 'firebase/auth'; // Import Firebase Auth

const adminEmails = ['kmarieinc1998@gmail.com', 'bettymondon@gmail.com'];

const BottomNavigationBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = React.useState(location.pathname);
  const [isAdmin, setIsAdmin] = React.useState(false);

  // Sync navigation value with current route and check user's admin status
  React.useEffect(() => {
    setValue(location.pathname);

    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setIsAdmin(adminEmails.includes(user.email));
      } else {
        setIsAdmin(false);
      }
    });

    return () => unsubscribe(); // Cleanup the listener
  }, [location.pathname]);

  return (
    <BottomNavigation
      sx={styles.bottomNav}
      value={value}
      onChange={(event, newValue) => {
        setValue(newValue);
        navigate(newValue);
      }}
    >
      <BottomNavigationAction
        label="Home"
        value="/home"
        icon={<HomeIcon />}
        sx={styles.navAction}
      />
      <BottomNavigationAction
        label="Matches"
        value="/matches"
        icon={<FavoriteIcon />}
        sx={styles.navAction}
      />

      <BottomNavigationAction
        label="Messages"
        value="/messages"
        icon={<MessageIcon />}
        sx={styles.navAction}
      />
      <BottomNavigationAction
        label="Profile"
        value="/profile"
        icon={<PersonIcon />}
        sx={styles.navAction}
      />
    </BottomNavigation>
  );
};

const styles = {
  bottomNav: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: '#FFF',
    boxShadow: '0 -2px 5px rgba(0,0,0,0.1)',
    zIndex: 1000,
  },
  navAction: {
    '&.Mui-selected': {
      color: '#C00068',
    },
    '& .MuiBottomNavigationAction-label': {
      fontSize: '12px',
      mt: '2px',
    },
  },
};

export default BottomNavigationBar;